import { AttributeRow, type AttributeVisibility } from '@civilgrid/ui/components';
import { useSnapshot } from 'valtio';
import layerStore from '~/store2/layers';
import type { SidebarFieldRow } from './buildSidebarSections';

// Binds the shared AttributeRow to the valtio layer store; returns it unwrapped so the
// parent's `even:` zebra striping keeps working across sibling rows.
export default function MetadataAttributeRow({ row, onLinkOpen }: { row: SidebarFieldRow; onLinkOpen: () => void }) {
  const { visibleMetadataIds } = useSnapshot(layerStore);
  const isOn = visibleMetadataIds.has(row.uniqueId);
  // Rows without eye support can't be toggled on the map, so they stay unavailable.
  let visibility: AttributeVisibility = 'unavailable';
  if (row.eyeSupported) visibility = isOn ? 'visible' : 'hidden';

  return (
    <AttributeRow
      label={row.label}
      value={row.value}
      valueEmpty={row.isEmpty}
      href={row.isUrl ? row.value : undefined}
      onLinkClick={row.isUrl ? onLinkOpen : undefined}
      visibility={visibility}
      onToggleVisibility={() =>
        isOn ? layerStore.visibleMetadataIds.delete(row.uniqueId) : layerStore.visibleMetadataIds.add(row.uniqueId)
      }
      className="even:bg-grey-10"
      data-testid={`metadata-sidebar-field-${row.uniqueId}`}
      visibilityToggleTestId={`metadata-sidebar-eye-${row.uniqueId}`}
      linkTestId={`metadata-sidebar-link-${row.uniqueId}`}
    />
  );
}
